/**
 * This util replace urls in string with anchor tags
 *
 * Special character allowed in path params: %_.~+-;
 * Special character allowed in query params: %_.~+-;
 * Special character allowed in query hash: ?/:@._~!$&'()*+,;=
 * Special characters allowed in domain: -
 * Special characters allowed in email: !#$%&'*+/=?^_`{|}~-]+@
 */

const isEmail = link => link.split('#')[0].indexOf('@') > -1

const getURLPattern = () => {
  const protocol = 'https?:\\/\\/'
  const subDomain = '[a-zA-Z0-9][-a-zA-Z0-9]+'
  const topLevelDomain = '[a-z]{2,6}'
  const port = '[0-9]{1,5}'
  const hash = "(#[-a-zA-Z\\d?/:@._~!$&'()*+,;=]*)"
  const path = '\\/[-a-zA-Z\\d%_.~+]*'
  const query = '(\\?[;&a-zA-Z\\d%_.~+=-]*)'
  const email = "[a-zA-Z0-9][a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@"
  return `(${protocol})?(${email})?((${subDomain})\\.){1,3}${topLevelDomain}(:${port})?(${path})*${query}?${hash}?`
}

export const urlPattern = getURLPattern()

export default function(string = '') {
  const regex = new RegExp(urlPattern, 'g')
  return string.replace(regex, function(url) {
    let href
    if (url.startsWith('http')) {
      href = url
    } else if (isEmail(url)) {
      href = `mailto:${url}`
    } else {
      href = `//${url}`
    }
    return `<a href="${href}" target="_blank" rel="nofollow noopener noreferrer">${url}</a>`
  })
}
